import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/about-us-case3.png")